import { instance } from "@/apis";
import { useQuery } from "@tanstack/react-query";

export const useChatShareQuery = ({
  chatId,
  isPrivate,
  enabled,
}: {
  chatId: string;
  isPrivate: boolean;
  enabled: boolean;
}) => {
  return useQuery({
    queryKey: ["chatShare", chatId, isPrivate],
    queryFn: async () => {
      return instance
        .get(`/api/df/user/chat/${chatId}/share?isPrivate=${isPrivate}`)
        .then((res) => res.data.data);
    },
    enabled,
  });
};
